export class TipoProducto {
    n?:string;
    id?:number;
    nombre?:string;
    descripcion?:string;
    fechareg?:string;
    fechamod?:string;
    activo?:number;
    current_user?:string;
    constructor(){}
}
